import request from '@/utils/ajax'


export function saveTelegramConfig(data) {
    return request({
        url: '/wx/manage/tgBotConfig/save',
        method: 'post',
        data: data
    })
}

export function editTelegramConfig(data) {
    return request({
        url: '/wx/manage/tgBotConfig/update',
        method: 'put',
        data: data
    })
}

export function deleteTelegramConfig(data) {
    return request({
        url: '/wx/manage/tgBotConfig/delete',
        method: 'post',
        data: data
    })
}
